/**
 * Quantity formatting shared by the DEA Logs surfaces (Administrations table,
 * Reconciliation table, Substances & Lots).
 *
 * Rules (21 CFR 1304 records are read by inspectors — every quantity column must
 * read the same way):
 * - `null`/`undefined` → `—` (genuinely absent). A stored `0` is NOT absent — the
 *   server coerces an omitted waste to 0 and the PDF already prints "0 mL" — so a
 *   zero renders as an explicit "0 <unit>", never as a dash.
 * - Unit is appended after a single space (`"100.000 mL"`), never concatenated.
 * - `decimals` fixes the precision (the Reconciliation table uses 3 to match the
 *   0.001 discrepancy tolerance and the lots table); omit it to print the raw
 *   number as the Administrations table always has (`"5 mL"`).
 */
export const fmtQty = (
  value: number | string | null | undefined,
  unit?: string | null,
  decimals?: number,
): string => {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const num = decimals == null ? String(n) : n.toFixed(decimals);
  const u = (unit ?? '').trim();
  return u ? `${num} ${u}` : num;
};
